var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-supplement"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.9773,
    cy: 35.9583,
    r: 23,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 0 0 0 0 5.1598 5.1598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.93,
    cy: 36.0066,
    r: 23.4291,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9773,
    cy: 35.9583,
    r: 23,
    fill: "none",
    stroke: "#f4aa41",
    strokeDasharray: "0 0 0 0 0 0 5.1598 5.1598",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.9772,32.9583c0,1.6569-1.3431,3-3,3s-3-1.3431-3-3,1.3431-3,3-3c1.6566.0006,2.9994,1.3434,3,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.9772,32.9583c0,1.6569-1.3431,3-3,3s-3-1.3431-3-3,1.3431-3,3-3c1.6566.0006,2.9994,1.3434,3,3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.9772,
    x2: 41.9772,
    y1: 43.7964,
    y2: 43.7964,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedFace);
export default __webpack_public_path__ + "static/media/dotted-face.e9847a8e5d70dce326fb55ecddff8a6a.svg";
export { ForwardRef as ReactComponent };